/**
 * Rankings of "My office network" (CU-869fmjzrh CA 17, 21/P6): over every office × column of the view, the top 5
 * most above the market, most below, and biggest change of your distance (points). Without identity, one card in
 * their place: where the market median moved most. Each entry opens its cell. Pure and alias-free.
 */
import { CHANGE_MIN_POINTS, MARKET_MOVE_MIN, RANK_MIN } from '../../../../../../@utils/colourScale.js'

export const TOP = 5
const isNum = v => typeof v === 'number' && Number.isFinite(v)

function cells(model) {
	const out = []
	model.rows.forEach((row, i) => {
		if (row.reason === 'notCaptured' || row.reason === 'noWebsite') return
		row.cells.forEach((cell, j) => out.push({ row: i, column: j, officeId: row.office.id, officeName: row.office.name, columnLabel: model.columns[j]?.label, cell }))
	})
	return out
}

const byName = (a, b) => String(a.officeName).localeCompare(String(b.officeName)) || a.column - b.column

export function rankings(model, top = TOP) {
	if (model.mode === 'market') return null
	const all = cells(model)
	const withDistance = all.filter(x => isNum(x.cell.distance))
	const above = withDistance.filter(x => x.cell.distance >= RANK_MIN).sort((a, b) => b.cell.distance - a.cell.distance || byName(a, b))
	const below = withDistance.filter(x => x.cell.distance <= -RANK_MIN).sort((a, b) => a.cell.distance - b.cell.distance || byName(a, b))
	const change = all.filter(x => isNum(x.cell.change) && Math.abs(x.cell.change) >= CHANGE_MIN_POINTS)
		.sort((a, b) => Math.abs(b.cell.change) - Math.abs(a.cell.change) || byName(a, b))
	const pick = (xs, key) => xs.slice(0, top).map(x => ({ ...x, value: x.cell[key] }))
	return { above: pick(above, 'distance'), below: pick(below, 'distance'), change: pick(change, 'change') }
}

/** P6: without identity, where the market median moved most (|change| ≥ 1 %, ≥ 2 competitors in both periods) */
export function marketMoves(model, top = TOP) {
	if (model.mode !== 'market') return null
	return cells(model)
		.filter(x => isNum(x.cell.marketChange) && Math.abs(x.cell.marketChange) >= MARKET_MOVE_MIN)
		.sort((a, b) => Math.abs(b.cell.marketChange) - Math.abs(a.cell.marketChange) || byName(a, b))
		.slice(0, top)
		.map(x => ({ ...x, value: x.cell.marketChange }))
}
